import React, { Component } from 'react';
import DashboardView from '../views/DashboardView';
import { base } from '../../base';

class DashboardContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            machines: [],
        };
    }

    componentDidMount() {
        this.valuesRef = base.syncState(`machines/${this.props.companyid}/`, {
            context: this,
            state: 'machines',
            asArray: true,
        });
    }

    componentWillReceiveProps(props) {
        if (this.props.companyid !== props.companyid) {
            if (this.valuesRef != null) base.removeBinding(this.valuesRef);
            this.valuesRef = base.syncState(`machines/${props.companyid}/`, {
                context: this,
                state: 'machines',
                asArray: true,
            });
        }
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        const { machines } = this.state;
        return (
            <div>
                <DashboardView
                    companyid={this.props.companyid}
                    company={this.props.company}
                    user={this.props.currentUser}
                    extraUser={this.props.extraUser}
                    machines={machines}
                />
            </div>
        );
    }
}

export default DashboardContainer;



// WEBPACK FOOTER //
// ./src/components/containers/DashboardContainer.js